import styled from "styled-components";

export const AreaMain = styled.div`
	transition: all 0.2s ease-in-out;
	padding: 0 1rem;
	width: 100%;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	background: ${({ theme }) => theme.white};
	width: 100%;
`;

export const HeaderScreen = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	padding: 1rem 0 0.5rem;
`;

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	margin-left: auto;
`;
